import * as React from 'react';
import { TryInStoreBanner as TryInStoreBanner$1 } from '@grandvisionhq/fun-try-in-store';
import { compose } from '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsTryInStoreBanner = ({})=>{
    return /*#__PURE__*/ React.createElement(TryInStoreBanner$1, null);
};
var TryInStoreBanner = compose(withHidableContent)(CmsTryInStoreBanner);

export { CmsTryInStoreBanner, TryInStoreBanner as default };
//# sourceMappingURL=TryInStoreBanner.js.map
